import { AfterViewInit, Component } from '@angular/core';
import { CalendlyUrl } from '../../../../core/enums/calendly-enums';

declare const Calendly: any;

@Component({
  selector: 'app-calendly-pv-analyse-dialog',
  standalone: true,
  imports: [],
  templateUrl: './calendly-pv-analyse-dialog.component.html',
  styleUrl: './calendly-pv-analyse-dialog.component.css'
})
export class CalendlyPvAnalyseDialogComponent implements AfterViewInit {
  modalDialogId: string = 'services_modal_pv_analyse'
  calendlyElementId: string = 'calendly-embed-pv';

  constructor() { }

  ngAfterViewInit(): void {
    Calendly.initInlineWidget({
      url: CalendlyUrl.PV_ANALYSE,
      parentElement: document.getElementById(this.calendlyElementId),
      text: 'Schedule time with me',
      color: '#80a7a5',
      textColor: '#ffffff',
      branding: true
    });
  }

  openModal() {
    let modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    modal.showModal();
  }

  closeModal(): void {
    let modal = document.getElementById(this.modalDialogId) as HTMLDialogElement;
    modal.close();
  }
} 
